var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0171 1.75H2.76709C1.31787 1.75 0.14209 2.92578 0.14209 4.375V23.625C0.14209 25.0742 1.31787 26.25 2.76709 26.25H22.0171C23.4663 26.25 24.6421 25.0742 24.6421 23.625V4.375C24.6421 2.92578 23.4663 1.75 22.0171 1.75ZM19.3429 10.4344C19.3538 10.5875 19.3538 10.7461 19.3538 10.8992C19.3538 15.6406 15.7444 21.1039 9.14912 21.1039C7.11475 21.1039 5.22803 20.5133 3.64209 19.4961C3.93193 19.5289 4.21084 19.5398 4.50615 19.5398C6.18506 19.5398 7.72725 18.9711 8.95771 18.0086C7.38271 17.9758 6.05928 16.9422 5.60537 15.5203C6.15771 15.6023 6.65537 15.6023 7.22412 15.4547C5.5835 15.1211 4.35303 13.6773 4.35303 11.9328V11.8891C4.82881 12.157 5.38662 12.3211 5.97178 12.343C5.47982 12.0157 5.07653 11.5718 4.79789 11.0508C4.51925 10.5298 4.37394 9.94788 4.3749 9.35703C4.3749 8.68984 4.5499 8.07734 4.86162 7.54688C6.62803 9.72344 9.28037 11.1453 12.2554 11.2984C11.7468 8.86484 13.5679 6.89062 15.7554 6.89062C16.789 6.89062 17.7187 7.32266 18.3749 8.02266C19.1843 7.86953 19.9608 7.56875 20.6499 7.15859C20.3819 7.98984 19.8187 8.68984 19.0749 9.13281C19.7968 9.05625 20.4968 8.85391 21.1421 8.575C20.6554 9.29141 20.0429 9.92578 19.3429 10.4344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white",
    transform: "translate(0.14209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9b19f09d3d64a2e864c6213f8e275e4.svg";
export { ForwardRef as ReactComponent };